import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { BodyText, Field, Notice, StepCard, StepTitle } from '../../components/ui'

/** Design manual p.8 — Attestation (after the entity loop, before the OTR submission). */
export function StepAttestation() {
  const { state, dispatch } = useOnboarding()

  return (
    <StepCard>
      <StepTitle>Attestation Statement</StepTitle>
      <Stack spacing={3}>
        <BodyText>
          If we identify unfiled transactions that we would like MISC to handle, we understand that we must include those
          transactions on an open tax report and submit them to MISC for processing.
        </BodyText>
        <Notice tone="info">
          Depending on the transaction effective date and home state involved, revised state reports may be required.
          Additional fees may apply.
        </Notice>

        <Box>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: '#0f172a' }}>Required Verification</Typography>
          <Typography sx={{ mt: 0.5, fontSize: 13, color: '#475569' }}>Choose one:</Typography>
          <FormControlLabel
            sx={{ mt: 1 }}
            control={
              <Checkbox
                checked={state.attestation.checked}
                onChange={(e) => dispatch({ type: 'SET_ATTESTATION', patch: { checked: e.target.checked } })}
              />
            }
            label={<Typography sx={{ fontSize: 15 }}>I confirm the attestation statement above.</Typography>}
          />
          <Typography sx={{ my: 1, fontSize: 13, fontWeight: 600, color: '#64748b' }}>OR</Typography>
          <Field
            label="Initials"
            value={state.attestation.initials}
            inputProps={{ maxLength: 12, style: { textTransform: 'uppercase', letterSpacing: '0.05em' } }}
            onChange={(e) => dispatch({ type: 'SET_ATTESTATION', patch: { initials: e.target.value } })}
            sx={{ maxWidth: 200 }}
          />
        </Box>
      </Stack>
    </StepCard>
  )
}
